import React from 'react';

import { Chip } from '@material-ui/core';
import { Lock, SettingsOutlined } from '@material-ui/icons';
import Visibility from '@material-ui/icons/Visibility';
import { Link } from 'react-router-dom';

import { resourcePrivacy } from '../../models/Resource';

export default ({ classes, workspaceName, currentUserName, isMediphanyWorkspace }) => {
  return [
    { label: 'Title', name: 'title' },

    {
      label: 'Description',
      name: 'description',
      render: (value) => {
        return <span className={classes.tableDescription}>{value}</span>;
      },
    },

    {
      label: 'Tags',
      name: 'tags',
      render: (_v, data) => {
        return (
          <div className={classes.tableTagsColumnContainer}>
            {(data.tags || []).map((tag) => (
              <Chip key={`${data.id}-tags-${tag}`} className={classes.tableTagsChip} label={tag} size="small" color="primary" />
            ))}
          </div>
        );
      },
    },
    {
      label: 'Privacy Settings',
      name: 'privacy',
      render: (_v, data) => {
        if (data.privacy === resourcePrivacy.GLOBAL) {
          return <span className={classes.tablePrivacyWorkspace}>Mediphany Global</span>;
        }

        if (data.privacy === resourcePrivacy.WORKSPACE) {
          return <span className={classes.tablePrivacyWorkspace}>{workspaceName}</span>;
        }

        return (
          <span className={classes.tablePrivacyUser}>
            <Lock className={classes.tablePrivacyUserIcon} size="small" />
            Private - {currentUserName}
          </span>
        );
      },
    },

    {
      label: '',
      name: 'id',
      render: (_value, data) => {
        if (data.privacy === resourcePrivacy.GLOBAL && !isMediphanyWorkspace) {
          return (
            <div>
              <Link to={`/collections/${data.id}`} className={classes.tableActionColumnContainer}>
                <Visibility className={classes.tableActionIcon} size="small" />
                VIEW
              </Link>
            </div>
          );
        }

        return (
          <div>
            <Link to={`/collections/${data.id}`} className={classes.tableActionColumnContainer}>
              <SettingsOutlined className={classes.tableActionIcon} size="small" />
              MANAGE
            </Link>
          </div>
        );
      },
    },
  ];
};
